import React, { useEffect, useRef, useState } from 'react';
import Logo from '../assets/lumus.svg';

const BannerHeader = ({ title, subtitle }: { title: string; subtitle: string }) => {
  const bannerRef = useRef<HTMLDivElement | null>(null);
  const [showStickyBanner, setShowStickyBanner] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // If banner is NOT intersecting, show sticky banner
        setShowStickyBanner(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      if (bannerRef.current) {
        observer.unobserve(bannerRef.current);
      }
    };
  }, []);

  return (
    <>
      {showStickyBanner && (
        <div className="sticky-mini-banner visible">
          <img src={Logo} alt="Lumus Logo" />
          <span>{title}</span>
        </div>
      )}

      <div className="landing-banner" ref={bannerRef}>
        <div className="banner-wrapper">
          <img src={Logo} alt="banner-img" />
        </div>
        <div className="banner-heading">
          <span>{title}</span>
          <p>{subtitle}</p>
        </div>
      </div>
    </>
  );
};

export default BannerHeader;
